import { getAvailable } from '../../data';
import { saveOptions, savePresets } from '../../data/storage';
import { deepClone } from '../../util';

export const addPrize = (state, prize) => {
  state.options.prizes.push(prize);
};

export const fetchPerson = (state, person) => {
  // console.log(person, "< mutation person spin")
  const arrPersonGp = person?.filter(item => {
    if (!item.status && !item.grandPrizeAvailable) {
      return item
    }
  }).sort(() => 0.5 - Math.random())
  // console.log(arrPersonGp, "<< arrPersonDp")
  state.person = arrPersonGp?.map(item => item).slice(0, 4)
}

export const SET_GRANDPRIZE = (state, prize) => {
  state.grandprizes = prize
  // console.log(state.grandprizes, "< mutation prize")
}


// Add the prize at the given index to the records.
export const addSpinResult = (state, index) => {
  state.totalSpins++;
  state.spins++;
  state.lastResult = index;
  state.records.push(state.available[index].name);
};

export const hideOptions = state => {
  state.showOptions = false;
};

export const loadPreset = (state, data) => {
  if (data) {
    // state.options = deepClone(data);
    state.preset = state.getters.modifiedPreset
  }
};

export const removePreset = (state, index) => {
  state.presets.splice(index, 1);
  savePresets(state.presets);
};

export const removePrize = (state, index) => {
  console.log(state.options, index, state.options.prizes)
  state.person.splice(index, 1);
};

// Save current wheel data to storage, and reset the wheel.
export const saveAndReset = state => {
  state.spins = 0;
  state.lastResult = -1;
  state.records = [];
  state.data = deepClone(state.options);
  state.available = deepClone(getAvailable(state.data.prizes));
  saveOptions(state.options, 'wofOptions');
};

export const saveNewPreset = (state, name) => {
  state.presets.push({ name, data: deepClone(state.data) });
  savePresets(state.presets);
};

export const savePreset = (state, index) => {
  state.presets[index].data = deepClone(state.data);
  savePresets(state.getters.modifiedPreset);
};

export const showOptions = state => {
  // console.log(state, '<< di mutasi')
  
  state.showOptions = true;
};

// If removeWinning is set to true, make the last spin result unavailable.
export const updateAvailable = state => {
  if (state.lastResult !== -1 ) {
    state.available.splice(state.lastResult, 1);
    state.lastResult = -1;
  }
};

export const updateWheelSize = (state, size) => {
  state.size = size;
};
